import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace("://billing.definesalon.com", "://billing.definesalons.com");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Suppress AxiosError 403 unhandled-rejections from surfacing as the React dev
// error overlay — access is already denied server-side and guarded by routes.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.response?.status === 403) e.preventDefault();
  });
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ds_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const path = window.location.pathname;
    if (status === 401 && !path.startsWith("/login")) {
      localStorage.removeItem("ds_token");
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
